export const LANGUAGES = [
    { 
        code: 'us',
        title: 'English'
    },
    { 
        code: 'se',
        title: 'Svenska'
    },
    { 
        code: 'es',
        title: 'Español'
    }
]